6 <template>
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <!-- Dashboard -->
      <li class="nav-item" v-if="canViewDashboard">
        <sidenav-collapse to="/dashboard" activeRoute="dashboard" navText="Dashboard">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Subjects -->
      <li class="nav-item" v-if="canViewSubjects">
        <sidenav-collapse to="/subjects" activeRoute="subjects" navText="المواد">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">menu_book</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Courses -->
      <li class="nav-item" v-if="canViewCourses">
        <sidenav-collapse to="/courses" activeRoute="courses" navText="الدروس">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">school</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Course Sessions -->
      <li class="nav-item" v-if="canViewCourseSessions">
        <sidenav-collapse to="/course-sessions" activeRoute="AllCourseSessionsList" navText="الدروس المباشرة ">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">event</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Question Bank (بنك الأسئلة) -->
      <li class="nav-item" v-if="canViewQuestionBank">
        <sidenav-collapse
            navText="بنك الأسئلة"
            :children="[
            { to: '/question-bank/session-questions',        navText: 'أسئلة الدرس',       activeRoute: 'SessionQuestions',       icon: 'quiz' },
            { to: '/question-bank/session-question-options', navText: 'اختيارات الإجابات', activeRoute: 'SessionQuestionOptions', icon: 'format_list_bulleted' },
            { to: '/question-bank/session-submissions',      navText: 'إجابات الطلاب',      activeRoute: 'SessionSubmissions',     icon: 'assignment_turned_in' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">quiz</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Homework -->
      <li class="nav-item" v-if="canViewHomework">
        <sidenav-collapse
            navText="الواجبات"
            :children="[
            { to: '/homework', navText: 'جميع الواجبات', activeRoute: 'HomeworkList', icon: 'assignment' },
            { to: '/homework/create', navText: 'إضافة واجب جديد', activeRoute: 'HomeworkCreate', icon: 'add' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">assignment</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- WhatsApp -->
      <li class="nav-item">
        <sidenav-collapse
            navText="الواتساب"
            :children="[
            { to: '/whatsapp-reports', navText: 'تقارير الواتساب', activeRoute: 'whatsapp-reports', icon: 'description' },
            { to: '/whatsapp-reminders', navText: 'إعدادات رسائل التذكير', activeRoute: 'whatsapp-reminders', icon: 'settings' },
            { to: '/whatsapp/otp-logs', navText: 'سجل OTP', activeRoute: 'OtpLogs', icon: 'history' }
          ]"
        >
          <template #icon>
            <i class="fab fa-whatsapp opacity-10 fs-5"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Teachers -->
      <li class="nav-item" v-if="canViewTeachers">
        <sidenav-collapse to="/teachers" activeRoute="teachers" navText="المعلمين">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">person</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - الحجوزات -->
      <li class="nav-item" v-if="canViewReservations">
        <sidenav-collapse
            navText="الحجوزات"
            :children="reservationChildren"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">pending_actions</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - الطلاب -->
      <li class="nav-item" v-if="canViewUsers">
        <sidenav-collapse
            navText="الطلاب"
            :children="[
            { to: '/admin/users', navText: 'جميع الطلاب', activeRoute: 'Users', icon: 'group' },
            { to: '/admin/users/create', navText: 'إضافة طالب', activeRoute: 'UserCreate', icon: 'person_add' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">group</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - المشرفين -->
      <li class="nav-item" v-if="canViewModerators">
        <sidenav-collapse
            navText="المشرفين"
            :children="[
            { to: '/admin/moderators', navText: 'جميع المشرفين', activeRoute: 'Moderators', icon: 'group' },
            { to: '/admin/moderators/create', navText: 'إضافة مشرف', activeRoute: 'ModeratorCreate', icon: 'person_add' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">security</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Admin - إدارة الأدوار والصلاحيات -->
      <li class="nav-item" v-if="canViewRoleManagement">
        <sidenav-collapse
            navText="إدارة الأدوار والصلاحيات"
            :children="[
            { to: '/admin/roles', navText: 'إدارة الأدوار', activeRoute: 'RoleManagement', icon: 'admin_panel_settings' },
            { to: '/admin/users/roles', navText: 'تعيين الأدوار', activeRoute: 'UserRoleAssignment', icon: 'person_add' }
          ]"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">admin_panel_settings</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Meetings -->
      <li class="nav-item" v-if="canViewMeetings">
        <sidenav-collapse to="/meetings" activeRoute="meetings" navText="إدارة الاجتماعات">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">videocam</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Google Drive -->
      <li class="nav-item" v-if="canViewGoogleDrive">
        <sidenav-collapse to="/drive/folder/root" activeRoute="FolderView" navText="جوجل درايف">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">cloud_queue</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Google Auth Redirect -->
      <li class="nav-item" v-if="canViewGoogleAuthRedirect">
        <sidenav-collapse to="/google-auth-redirect" activeRoute="GoogleAuthRedirect" navText="مصادقة">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">vpn_key</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- YouTube Channels -->
      <li class="nav-item" v-if="canViewYoutubeChannels">
        <sidenav-collapse to="/google-channels" activeRoute="GoogleChannels" navText="قنوات يوتيوب">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">ondemand_video</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Facebook Pages -->
      <li class="nav-item" v-if="canViewFacebookPages">
        <sidenav-collapse to="/facebook-pages" activeRoute="FacebookPages" navText="صفحات فيسبوك">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">facebook</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- TikTok Accounts -->
      <li class="nav-item" v-if="canViewTikTokAccounts">
        <sidenav-collapse to="/tiktok-accounts" activeRoute="TikTokAccounts" navText="حساب تيك توك">
          <template #icon>
            <i class="fab fa-tiktok opacity-10 fs-6"></i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Notifications -->
      <li class="nav-item" v-if="canViewNotifications">
        <sidenav-collapse to="/admin/notifications/manual" activeRoute="ManualNotification" navText="إرسال إشعارات">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">notifications_active</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import permissionsMixin from "@/mixins/permissions";

export default {
  name: "SidenavList",
  components: { SidenavCollapse },
  mixins: [permissionsMixin],
  computed: {
    canViewDashboard() {
      // Only allow dashboard access if user has specific dashboard permission or is admin
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view dashboard', 'view-dashboard'
      ]);
    },
    canViewGoogleDrive() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view google drive', 'view-google-drive'
      ]);
    },
    canViewGoogleAuthRedirect() {
      return true; // For now, make it always visible for testing
    },
    canViewSubjects() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view subjects', 'view-subjects',
        'create subjects', 'create-subjects',
        'edit subjects', 'edit-subjects'
      ]);
    },
    canViewCourses() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view courses', 'view-courses',
        'create courses', 'create-courses',
        'edit courses', 'edit-courses'
      ]);
    },
    canViewCourseSessions() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view sessions', 'view-sessions',
        'create sessions', 'create-sessions',
        'edit sessions', 'edit-sessions'
      ]);
    },
    canViewQuestionBank() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view questions', 'view-questions',
        'create questions', 'create-questions',
        'edit questions', 'edit-questions',
        'view question options', 'view-question-options',
        'create question options', 'create-question-options',
        'edit question options', 'edit-question-options',
        'view answers', 'view-answers',
        'create answers', 'create-answers',
        'edit answers', 'edit-answers'
      ]);
    },
    canViewHomework() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view homework', 'view-homework',
        'create homework', 'create-homework',
        'edit homework', 'edit-homework'
      ]);
    },
    canViewTeachers() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view teachers', 'view-teachers',
        'create teachers', 'create-teachers',
        'edit teachers', 'edit-teachers'
      ]);
    },
    canViewReservations() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view reservations', 'view-reservations',
        'create reservations', 'create-reservations',
        'edit reservations', 'edit-reservations'
      ]);
    },
    reservationChildren() {
      const items = [];
      if (this.isSuperAdmin() || this.checkAnyPermission(['view reservations', 'view-reservations'])) {
        items.push({ to: '/admin/reservations', navText: 'جميع الحجوزات', activeRoute: 'ReservationsIndex', icon: 'list' });
        items.push({ to: '/admin/reservations/calendar', navText: 'تقويم الحجوزات', activeRoute: 'ReservationCalendar', icon: 'calendar_today' });
      }
      if (this.isSuperAdmin() || this.checkAnyPermission(['create reservations', 'create-reservations', 'create reservation', 'create-reservation'])) {
        items.push({ to: '/admin/reservations/create', navText: 'حجز جديد', activeRoute: 'ReservationCreate', icon: 'add' });
        items.push({ to: '/admin/reservations/custom', navText: 'حجز مخصص (سلة)', activeRoute: 'CustomReservationCreate', icon: 'shopping_cart' });
      }
      return items;
    },
    canViewUsers() { // New computed property for Users
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view users', 'view-users',
        'create users', 'create-users',
        'edit users', 'edit-users'
      ]);
    },
    canViewModerators() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view users', 'view-users',
        'create users', 'create-users'
      ]);
    },
    canCreateModerators() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'create users', 'create-users'
      ]);
    },
    canViewWallet() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view wallets', 'view-wallets',
        'manage wallets', 'manage-wallets',
        'manage wallet', 'manage-wallet'
      ]);
    },
    canViewRoleManagement() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view roles', 'view-roles',
        'create roles', 'create-roles',
        'edit roles', 'edit-roles',
        'assign roles', 'assign-roles'
      ]);
    },
    canViewMeetings() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view meetings', 'view-meetings',
        'create meetings', 'create-meetings',
        'edit meetings', 'edit-meetings'
      ]);
    },
    canViewYoutubeChannels() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view youtube channels', 'view-youtube-channels'
      ]);
    },
    canViewFacebookPages() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view facebook pages', 'view-facebook-pages'
      ]);
    },
    canViewTikTokAccounts() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'view tiktok accounts', 'view-tiktok-accounts'
      ]);
    },
    canViewNotifications() {
      return this.isSuperAdmin() || this.checkAnyPermission([
        'send notifications', 'send-notifications'
      ]);
    },
  }
};
</script>
